/* eslint-disable @typescript-eslint/no-deprecated */

import React from 'react'
import styled, { useTheme } from 'styled-components'
import { industryCategoryToIndustryCategoryTitle, Organization } from '../../domain'
import { Text, Caption } from '../../styles'
import { OrganizationLogoWithFallback } from '../OrganizationLogoWithFallback'

interface Props {
  organization: Organization
  onClick?: () => void
}

export const OrganizationGroup: React.FC<Props> = ({ organization: { logoUrl, industryCategory, title }, onClick }) => {
  const { colors } = useTheme()
  return (
    <Container onClick={onClick}>
      <OrganizationLogoWithFallback src={logoUrl} alt={title} style={IMAGE_STYLE} />
      <Column>
        <Text weight="800" as="span" color={colors.dark}>
          {title}
        </Text>
        <Caption color={colors.grey.dark}>{industryCategoryToIndustryCategoryTitle(industryCategory)}</Caption>
      </Column>
    </Container>
  )
}

const SPACING = 1

const IMAGE_STYLE = {
  overflow: 'hidden',
  margin: '0 2rem 0 0',
  width: '50px',
  height: '50px',
}

const Container = styled.div`
  cursor: ${(props) => (props.onClick ? 'pointer' : 'default')};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: ${SPACING}rem 0;
  margin-bottom: ${SPACING}rem;
`

const Column = styled.div`
  display: flex;
  flex-direction: column;
`
